import { Pipe, PipeTransform } from '@angular/core';

import { isColumnPercentage } from '@blaze-runtime/engine-domain';
import { BlazeSchema } from '@blaze-shared/schema-domain';

@Pipe({
  name: 'isColumnPercentage',
})
export class IsColumnPercentagePipe implements PipeTransform {
  transform(columnName: string, schema: BlazeSchema | undefined): boolean {
    return isColumnPercentage(columnName, schema);
  }
}
